/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

export const googleMapsKey = 'AIzaSyAnWJSarkqgNTx5ocG3PjsFUKrCNCuAnaQ';
export const autoUpdate = true;
export const baiduMap = false;
export const i18nBackendLoadPath = '/locales/{{lng}}/{{ns}}.json';
export const baseURL = 'https://backend.soundtalksweb.com';
export const captchaKey = '0x4AAAAAAAC1i7NfhXPuEVyS';
export const reversedFullName = false;
export const apkDownloadUrl = null;
export const isDemo = false;
export const enableSubscription = false;
export const isChinaConfig = false;
export const allowedDownloadDomains = [
  'soundtalks-prd-s3-backend-batch-exports.s3.eu-west-1.amazonaws.com', // Batch exports
  'd2cvzqdyl07rjj.cloudfront.net', // Audio snippets
];
